import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

import { Link } from "react-router-dom";



export default function SliderOurClients() {
    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}

                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 1,
                        spaceBetween: 10,
                    },
                    '@0.75': {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    '@1.00': {
                        slidesPerView: 2,
                        spaceBetween: 40,
                    },
                    '@1.50': {
                        slidesPerView: 5,
                        spaceBetween: 50,
                    },
                }}
                modules={[Autoplay]}
                className="mySwiper container"
            >


                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="6 / 12" style={{ width: '160px', marginRight: 80 }} data-swiper-slide-index={5}>
                        <img src="assets/img/bh.png" alt="client-logo-6" width={223} height={90} className="img-fluid" />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="6 / 12" style={{ width: '160px', marginRight: 80 }} data-swiper-slide-index={5}>
                        <img src="assets/img/Feedback Foundation.png" alt="client-logo-6" width={123} height={29} className="img-fluid" />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="6 / 12" style={{ width: '160px', marginRight: 80 }} data-swiper-slide-index={5}>
                        <img src="assets/img/Saurashtra Enviro Project Pvt Ltd.png" alt="client-logo-6" width={123} height={29} className="img-fluid" />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="6 / 12" style={{ width: '300px', marginRight: 80 }} data-swiper-slide-index={5}>
                        <img src="assets/img/Mahakoshal Refratory Pvt LTD.png" alt="client-logo-6" width={123} height={29} className="img-fluid" />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="6 / 12" style={{ width: '160px', marginRight: 80 }} data-swiper-slide-index={5}>
                        <img src="assets/img/ReSustainability Services Private Limit.svg" alt="client-logo-6" width={123} height={29} className="img-fluid" />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="6 / 12" style={{ width: '160px', marginRight: 80 }} data-swiper-slide-index={5}>
                        <img src="assets/img/IPCA Enviro Pvt Ltd.webp" alt="client-logo-6" width={123} height={29} className="img-fluid" />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="6 / 12" style={{ width: '160px', marginRight: 80 }} data-swiper-slide-index={5}>
                        <img src="assets/img/Shakti Plastics Industries Ltd. Mumbai(MH).png" alt="client-logo-6" width={123} height={29} className="img-fluid" />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="6 / 12" style={{ width: '160px', marginRight: 80 }} data-swiper-slide-index={5}>
                        <img src="assets/img/REKART INNOVATIONS PVT LTD.png" alt="client-logo-6" width={123} height={29} className="img-fluid" />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="6 / 12" style={{ width: '160px', marginRight: 80 }} data-swiper-slide-index={5}>
                        <img src="assets/img/MALTI ENTERPRIES.png" alt="client-logo-6" width={123} height={29} className="img-fluid" />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="6 / 12" style={{ width: '160px', marginRight: 80 }} data-swiper-slide-index={5}>
                        <img src="assets/img/Horizon solutions.jpeg" alt="client-logo-6" width={123} height={29} className="img-fluid" />
                    </div>
                </SwiperSlide>
                  <SwiperSlide>
                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="6 / 12" style={{ width: '160px', marginRight: 80 }} data-swiper-slide-index={5}>
                        <img src="assets/img/ECOGATEWAY PVT LTD.jpg" alt="client-logo-6" width={123} height={29} className="img-fluid" />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="6 / 12" style={{ width: '160px', marginRight: 80 }} data-swiper-slide-index={5}>
                        <img src="assets/img/ECO GREEN ENERGY LUCKNOW PVT LTD.png" alt="client-logo-6" width={123} height={29} className="img-fluid" />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="6 / 12" style={{ width: '160px', marginRight: 80 }} data-swiper-slide-index={5}>
                        <img src="assets/img/Hindalco Industries LTD.webp" alt="client-logo-6" width={123} height={29} className="img-fluid" />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="6 / 12" style={{ width: '160px', marginRight: 80 }} data-swiper-slide-index={5}>
                        <img src="assets/img/GREEN TECH ENVIRO MANAGEMENT PVT LTD.jpeg" alt="client-logo-6" width={123} height={29} className="img-fluid" />
                    </div>
                </SwiperSlide>
              
                
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="6 / 12" style={{ width: '160px', marginRight: 80 }} data-swiper-slide-index={5}>
                        <img src="assets/img/AARAYA ENTERPRISES.jpeg" alt="client-logo-6" width={123} height={29} className="img-fluid" />
                    </div>
                </SwiperSlide>
              





            </Swiper>
        </>
    );
}
